import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { AppShell } from "@/components/layout/AppShell";
import { RouteGuard } from "@/components/layout/RouteGuard";
import { DeploymentsSubnav, type DeploymentsSection as Section } from "./DeploymentsSubnav";

/** Shell shared by the Omnimizer subsections of Deployments. */
export function DeploymentsSection({
  section,
  description,
  children,
}: {
  section: Exclude<Section, "list">;
  description: string;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <RouteGuard allow={(p) => p.canViewDeployments}>
      <AppShell
        breadcrumbs={[
          { label: t("sidebar.deployments") },
          { label: t(`omnimizer.nav.${section === "new" ? "deploy" : section}`), current: true },
        ]}
        contentWidth="contained"
      >
        <div className="flex flex-col gap-5 px-4 py-6 sm:px-6 lg:py-8">
          <DeploymentsSubnav current={section} />
          <p className="text-sm text-muted-foreground">{description}</p>
          {children}
        </div>
      </AppShell>
    </RouteGuard>
  );
}
